import PasswordLinkExpired from './PasswordHasBeenChanged';

export default PasswordLinkExpired;